module.exports = __webpack_public_path__ + "media/images/games/fifa-23/hiw-2-3dfa4f88a33785f0167e5f3fe3c27006.jpg";